// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 850px) {
    .scl--jhbs-pad-cons-bo-stl {
        padding-left: var(--global-tablet-padding-left);
        padding-right: var(--global-tablet-padding-left);
    }

    .scl--jdms-bo-con-wid-st{
        padding-left: var(--global-tablet-padding-left);
        padding-right: var(--global-tablet-padding-left);
    }

    .scl--jhhs-des-sty{
        width: 67%;
    }

    .scl--jhhs-but-sty{
        width: 33%;
    }
    
    .scl--jd-btn-hea-st{
        width: 221px;
        height: 50px;
        border-radius: 30px;
    }

    .scl--jd-btn-hea-st .scl--web-component-round-button-text{
        font-size: 28px;
    }

    .scl--jd-btn-hea-st .scl--web-component-round-button-icon svg{
        width: 30px;
        height: 30px;
    }

    .scl--jcbst-hea-bo-st{
        min-height: 160px;
    }

    .scl--jemds-ti-tex-st{
        font-size: 40px;
    }

    .scl--jemds-par-tex-st{
        font-size: 28px;
    }

    .scl--jdms-eac-met-da-st{
        gap: 30px;
    }

    .scl--jdms-eac-met-da-st ul li{
        font-size: 28px;
        padding: 0px 0px 0px 12px;
    }

    .scl--jdms-eac-met-da-st li::before{
        content: "•";
        position: absolute;
        left: -20px;
        font-size: 25px;
        top: 25%;
        transform: translateY(-50%);
    }
        
}`, "",{"version":3,"sources":["webpack://./src/page-module/page-services/job-detail/css/jobDetailSt.css"],"names":[],"mappings":"AAAA;IACI;QACI,+CAA+C;QAC/C,gDAAgD;IACpD;;IAEA;QACI,+CAA+C;QAC/C,gDAAgD;IACpD;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;QACf,yBAAyB;IAC7B;;IAEA;QACI,YAAY;QACZ,kBAAkB;QAClB,WAAW;QACX,eAAe;QACf,QAAQ;QACR,2BAA2B;IAC/B;;AAEJ","sourcesContent":["@media (max-width: 850px) {\n    .scl--jhbs-pad-cons-bo-stl {\n        padding-left: var(--global-tablet-padding-left);\n        padding-right: var(--global-tablet-padding-left);\n    }\n\n    .scl--jdms-bo-con-wid-st{\n        padding-left: var(--global-tablet-padding-left);\n        padding-right: var(--global-tablet-padding-left);\n    }\n\n    .scl--jhhs-des-sty{\n        width: 67%;\n    }\n\n    .scl--jhhs-but-sty{\n        width: 33%;\n    }\n    \n    .scl--jd-btn-hea-st{\n        width: 221px;\n        height: 50px;\n        border-radius: 30px;\n    }\n\n    .scl--jd-btn-hea-st .scl--web-component-round-button-text{\n        font-size: 28px;\n    }\n\n    .scl--jd-btn-hea-st .scl--web-component-round-button-icon svg{\n        width: 30px;\n        height: 30px;\n    }\n\n    .scl--jcbst-hea-bo-st{\n        min-height: 160px;\n    }\n\n    .scl--jemds-ti-tex-st{\n        font-size: 40px;\n    }\n\n    .scl--jemds-par-tex-st{\n        font-size: 28px;\n    }\n\n    .scl--jdms-eac-met-da-st{\n        gap: 30px;\n    }\n\n    .scl--jdms-eac-met-da-st ul li{\n        font-size: 28px;\n        padding: 0px 0px 0px 12px;\n    }\n\n    .scl--jdms-eac-met-da-st li::before{\n        content: \"•\";\n        position: absolute;\n        left: -20px;\n        font-size: 25px;\n        top: 25%;\n        transform: translateY(-50%);\n    }\n        \n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
